import PropTypes from 'prop-types';
import * as React from 'react';

const validTypes = ['sizinginfo', 'availability', 'quickquote', 'constraints'];

const getPopupLink = (type, styleId, productPath) => {
  const deconstructedPath = productPath && productPath.split('/');

  switch (type) {
    case 'sizinginfo':
      return `${window.location.origin}/items/sizing/${styleId}_lineup/standard.htm`;
    case 'availability':
      return `${window.location.origin}/styles/sizing/${styleId}`;
    case 'quickquote':
      return `${window.location.origin}/quotes?product_id=${styleId}`;
    case 'constraints':
      return `${window.location.origin}/products/styles/${deconstructedPath[deconstructedPath.length - 2]}/${styleId}/constraints`;
    default:
      return null;
  }
};

const getPopupSizing = (type) => {
  switch (type) {
    case 'sizinginfo':
      return 'width=640,height=700';
    case 'availability':
      return 'width=620,height=785';
    case 'quickquote':
      return 'width=400,height=615';
    case 'constraints':
      return 'width=640,height=700';
    default:
      return null;
  }
};

const QuickViewPopup = ({children, productPath, styleId, type}) => {
  if (!styleId) {
    return null;
  }
  if (!validTypes.includes(type)) {
    return null;
  }
  if (type === 'constraints' && !productPath) {
    return null;
  }

  return (
    <a
      data-popup-name={type === 'constraints' ? 'sizinginfo' : type}
      data-popup-options={`${getPopupSizing(type)},scrollbars=yes,tollbar=yes,menubar=no,location=yes,reziable=yes`}
      href={getPopupLink(type, styleId, productPath)}>
      {children}
    </a>
  );
};

export default QuickViewPopup;

QuickViewPopup.propTypes = {
  children: PropTypes.node,
  productPath: PropTypes.string,
  styleId: PropTypes.number,
  type: PropTypes.oneOf(validTypes).isRequired
};
